import { DataGridPremium } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ExportExcelFromUrl from "../../../components/mui/app/exportExcelFromUrl/exportExcelFromUrl";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import CustomToolbar from "../../../components/mui/grids/dataGridCustom/customToolbar/customToolbar";
import { API } from "../../../helpers/constants";
import { muiGridLocales } from "../../../helpers/mui/muiLocales";
import { REPORTS } from "../locales/namespaces";


export function WorkersInProjectsGridContainer({
                                        data,
                                        isLoading,
                                        page,
                                        pageSize,
                                        onFilterModelChange,
                                        onPaginationModelChange,
                                        onSortModelChange,
                                        total,
                                        language,


                                    }) {
    const { t } = useTranslation(REPORTS);

    const columns = useMemo(() => {
        return [
            {
                field: "Description",
                headerName: t("Worker"),
                minWidth: 300,
                flex: 1,
            },
            {
                field: "Projects",
                headerName: t("Projects"),
                minWidth: 300,
                flex: 1,
            },
            {
                field: "WorkTm",
                headerName: t("Work Time"),
                minWidth: 120,
                flex: 1,
                type: 'number',
                valueGetter: (value) => value ? Number(value) : 0.00,
                aggregationFunction: 'sum',
            },
            {
                field: "ExtraWorkTmW",
                headerName: t("Extra Work Time(S-S)"),
                minWidth: 120,
                flex: 1,
                type: 'number',
                valueGetter: (value) => value ? Number(value) : 0.00,
                aggregationFunction: 'sum',
            },

        ];
    }, [t]);

    return (

        <DataGridPremium
            sx={{
                '& .MuiDataGrid-headerFilterRow': {
                    background: `linear-gradient(90deg, #e2e7e3 05%, #f6f7f7 95%)`
                },
                '& .MuiFormLabel-root': {
                    display: 'none',
                },
                '& .MuiDataGrid-pinnedRowBottom .MuiDataGrid-cell': {
                    color: 'black',
                    fontWeight: 'bold',
                },
                '& .MuiDataGrid-footerCell': {
                    color: 'black',
                    fontWeight: 'bold',
                }
            }}
            columns={columns}
            rows={data}
            pagination
            paginationModel={{ page, pageSize }}
            paginationMode="server"
            onPaginationModelChange={onPaginationModelChange}
            rowCount={Number(total)}
            pageSizeOptions={[5, 10, 15, 20, 50, 100]}
            sortingMode="server"
            onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
            filterMode="server"
            onFilterModelChange={onFilterModelChange}
            loading={isLoading}
            initialState={{
                density: 'compact',
                aggregation: {
                    model: {
                        WorkTm: 'sum',
                        ExtraWorkTm: 'sum',
                        WorkCost: 'sum',
                        ExtraWorkCost: 'sum',
                        WithContibutions: 'sum',
                    },
                },
                // aggregationRowsScope: 'bottom',
            }}
            slots={{
                pagination: CustomPagination,
                headerFilterMenu: null,
            }}
            disableColumnFilter
            headerFilters
            localeText={muiGridLocales(language)}
        />
    );
}
